import { Injectable } from '@angular/core';
// tslint:disable-next-line: import-name
import Dexie from 'dexie';

@Injectable()
export class DexieService {
    dexieDB: any;
    constructor() {
        this.dexieDB = new Dexie('moneytor.in');
        this.dexieDB.version(1).stores({
            addCommentOutbox: '++id,loggedInUserId,url,postData,file',
            accountsResponse: 'id',
            fiedlResponseTypes: 'id',
            phoneResponseTypes: 'id',
            phoneLogOutbox: '++id,loggedInUserId,url,postData,file'
        });
    }

    // @SET Accounts Page Response
    public getDexieAccountDBObj() {
        return this.dexieDB['accountsResponse'];
    }
    // GET Accounts Page Response
    public getDexieAccountTable() {
        return this.dexieDB.table('accountsResponse');
    }

    // @SET Field Action Response
    public getDexieRepsonseDBObj() {
        return this.dexieDB['fiedlResponseTypes'];
    }
    // @GET Field Action Response
    public getDexieResponseTable() {
        return this.dexieDB.table('fiedlResponseTypes');
    }

    // @SET Field Action OutBox
    public getDexieFieldDBObj() {
        return this.dexieDB['addCommentOutbox'];
    }
    // @GET Field Action OutBox
    public getDexieFieldTable() {
        return this.dexieDB.table('addCommentOutbox');
    }


    // @SET Phone Action Response
    public setPhoneActionTypes() {
        return this.dexieDB['phoneResponseTypes'];
    }
    // @GET Phone Action Response
    public getPhoneActionTypes() {
        return this.dexieDB.table('phoneResponseTypes');
    }


    // @SET Phone_LOG Action Response
    public setPhoneLogOutbox() {
        return this.dexieDB['phoneLogOutbox'];
    }
    // @GET Phone_LOG Action Response
    public getPhoneLogOutbox() {
        return this.dexieDB.table('phoneLogOutbox');
    }

}
